<template>
  <ais-search-box
    v-model="query"
    class="rendering-repository-search-box"
    autofocus
    :placeholder="'Search for images...' | t"
  >
    <template v-slot:submit-icon>
      <SloIcon name="MagnifyingGlass" />
    </template>
    <template v-slot:reset-icon>
      <SloIcon v-show="query" name="XMark" />
    </template>
  </ais-search-box>
</template>

<script>
import t from '../../main/i18n';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  data() {
    return {
      query: ''
    };
  },
  filters: {
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';

.rendering-repository-search-box {
  form {
    position: relative;
  }

  input {
    padding-left: 48px;
    padding-right: 48px;
    height: 48px;
    border-radius: 4px;
  }

  button {
    position: absolute;
    top: 0;
    width: 45px;
    height: 45px;
    border-radius: 0;
    background: transparent;
    color: $color-gray-700;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button[type='submit'] {
    left: 0;
  }

  button[type='reset'] {
    right: 0;
  }
}
</style>
